<template>
  <el-popover
    placement="top"
    width="240"
    trigger="hover"
    content="规格一般格式为：数字+单位*数字+单位...，数字+单位为最小单元，中间用*：等符号隔开。"
  >
    <i slot="reference" size="28" class="el-icon-question spec-icon"></i>
  </el-popover>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.spec-icon {
  color: #bfbfbf;
  font-size: 16px;
  margin-left: 4px;
}
</style>
